/**
 * Iter 79 — Pragmatic wrapper around useFieldConfig that exposes:
 *  - showField(id)              -> bool (false = hidden)
 *  - reqStar(id, defaultReq)    -> '*' when required, '' otherwise
 *  - isReq(id, defaultReq)      -> bool, drop into <input required={...}>
 *  - labelOf(id, defaultLabel)  -> string, server label OR caller default
 *  - helpOf(id)                 -> string|null
 *
 * Usage:
 *   const ff = useFormFieldHelpers('employee_master');
 *   {ff.showField('phone') && (
 *     <Field label={`${ff.labelOf('phone','Phone')}${ff.reqStar('phone',false)}`}>
 *       <input required={ff.isReq('phone', false)} ... />
 *       {ff.helpOf('phone') && <p className="text-[10px] text-slate-500">{ff.helpOf('phone')}</p>}
 *     </Field>
 *   )}
 */
import { useMemo } from 'react';
import { useFieldConfig } from './useFieldConfig';

export function useFormFieldHelpers(formId) {
  const fc = useFieldConfig(formId);
  return useMemo(() => ({
    loading: fc.loading,
    showField: (id) => !fc.isHidden(id, false),
    isReq: (id, defaultReq = false) => fc.isRequired(id, defaultReq),
    reqStar: (id, defaultReq = false) => (fc.isRequired(id, defaultReq) ? ' *' : ''),
    labelOf: (id, defaultLabel) => fc.label(id, defaultLabel),
    helpOf: (id) => fc.help(id),
  }), [fc]);
}
